import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../../queries/withCount';

const ERRORS = `errors { path, message }`;

const BUYER_USER_FIELDS = `
  id
  firstName
  lastName
  email
  role
  invitationSentAt
  invitationAcceptedAt
`

const BUYER_USER_VARIABLES = `
  $buyerId: ID!
  $contactId: ID
  $email: String!
  $firstName: String!
  $lastName: String!
  $role: String!
`;

const BUYER_USER_ARGUMENTS = `
  buyerId: $buyerId
  contactId: $contactId
  email: $email
  firstName: $firstName
  lastName: $lastName
  role: $role
`;

const EDIT_BUYER_USER_VARIABLES = `
  $id: ID!
  $email: String!
  $firstName: String!
  $lastName: String!
  $role: String
`;

const EDIT_BUYER_USER_ARGUMENTS = `
  id: $id
  email: $email
  firstName: $firstName
  lastName: $lastName
  role: $role
`;

const BUYER_USER_FIELDS_AND_ERRORS = `
  buyerUser {
    ${BUYER_USER_FIELDS}
  }
  ${ERRORS}
`;

export const BUYER_USERS_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
    $buyerId: ID!
  ) {
    buyerUsersWithCount(
      ${WITH_COUNT_ARGUMENTS}
      buyerId: $buyerId
    ) {
      entries {
        ${BUYER_USER_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_BUYER_USER = gql`
  mutation CreateBuyerUser(
    ${BUYER_USER_VARIABLES}
  ) {
    createBuyerUser(
      ${BUYER_USER_ARGUMENTS}
    ) {
      ${BUYER_USER_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_BUYER_USER = gql`
  mutation UpdateBuyerUser(
    ${EDIT_BUYER_USER_VARIABLES}
  ) {
    updateBuyerUser(
      ${EDIT_BUYER_USER_ARGUMENTS}
    ) {
      ${BUYER_USER_FIELDS_AND_ERRORS}
    }
  }
`;

export const BUYER_USER = gql`
  query BuyerUser($id: ID!) {
    buyerUser(id: $id) {
      ${BUYER_USER_FIELDS}
    }
  }
`;

export const HIDE_BUYER_USER = gql`
  mutation HideBuyerUser($id: ID!) {
    hideBuyerUser(id: $id) {
      buyerUser {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const UNHIDE_BUYER_USER = gql`
  mutation UnhideBuyerUser($id: ID!) {
    unhideBuyerUser(id: $id) {
      buyerUser {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const REINVITE_BUYER_USER = gql`
  mutation ReinviteBuyerUser(
    $id: ID!
  ) {
    reinviteBuyerUser(
      id: $id
    ) {
      buyerUser { id }
      errors { message, path }
    }
  }
`;
